import css from "styled-jsx/css";
import config from "lib/config";
const default_background = `${config.CDN_PREFIX}/static/assets/images/default_background.webp`;
const default_background_mobile = `${config.CDN_PREFIX}/static/assets/images/default_background_mobile.webp`;
import { rdcUiTheme } from "@rdc-npm/rdc-ui";
export default css`
  @import "src/static/styles/variables";
  @import "src/static/styles/mixins/mixins";
  ._preview-main_header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1001;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 7px 14px 0 rgba(0, 0, 0, 0.06);
    height: 140px;
  }
  #rev {
    text-decoration: none;
    cursor: pointer;
  }
  #rec {
    text-decoration: none;
    cursor: pointer;
  }
  header {
    transition: all 0.4s ease;
    display: none;
  }
  ._preview-main_header .container {
    // padding-left: 115px;
  }
  ._preview-main_header .container .profile-details-box-profile {
    width: 100%;
    padding: 10px 90px 10px 0px;
  }
  ._preview-main_header .profile-details-box-profile {
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: none;
    padding: 0;
    position: relative;
    width: 100%;
    margin-bottom: 0;
  }
  ._preview-main_header .profile-details-box-profile .profile-details {
    margin-top: 0;
    position: relative;
  }
  .profile-details {
    display: flex;
    align-items: start;
  }
  .profile-details .profile-img {
    max-width: 100%;
    height: 72px;
    width: 72px;
  }
  .profile-details .profile-img {
    height: 116px;
    width: 116px;
    max-width: 100%;
  }
  .profile-details-box-team-section {
    box-sizing: border-box;
    height: 73px !important;
    width: 73px !important;
    border: 0.5px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
    border-radius: 100px;
  }
  .profile-details .profile-img img {
    height: 72px;
    width: 72px;
    border-radius: 50%;
  }
  .profile-details-box-team-section img {
    height: 73px !important;
    width: 73px !important;
  }
  .profile-Tiltle {
    padding-left: 24px;
  }
  .badge {
    font-size: 14px;
    font-weight: ${rdcUiTheme.typography.weight.medium};
    color: ${rdcUiTheme.color.text.secondary};
    line-height: 20px;
  }
  .profile-Tiltle-main {
    margin: 0 0 0;
    letter-spacing: 0.5px;
    font-size: 24px;
    color: ${rdcUiTheme.color.text.primary};
    font-weight: ${rdcUiTheme.typography.weight.bold};
    line-height: 32px;
  }
  ._preview-main_header .profile-Tiltle-sub {
    color: $gray-dark;

    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 24px;
    width: 100%;
    max-width: 100%;
    margin: 0;
  }
  ._preview-main_header .profile-details-box {
    display: flex;
    align-items: center;
    padding-top: 10px;
  }
  .stickyspace {
    margin: 0 !important;
    display: flex;
  }
  p {
    margin: 0 0 10px;
  }
  .review-star {
    position: relative;
    top: -2px;
    left: -2px;
  }
  .review-star img {
    height: 16px;
    width: 16px;
    max-width: 100%;
  }
  a .review {
    color: #3377cc !important;
  }
  .review {
    color: ${rdcUiTheme.color.text.primary};
    font-weight: ${rdcUiTheme.typography.weight.medium};
    font-size: 14px;
  }
  .review1 {
    color: ${rdcUiTheme.color.text.secondary};
    font-size: 14px;
    line-height: 24px;
  }
  .separator-dot {
    margin-left: 10px;
    margin-right: 10px;
    color: #c8c8c8;
  }
  .review-recommendations {
    position: relative;
    top: 0px;
    left: -3px;
  }
  .review-recommendations img {
    width: 16px;
    height: 16px;
    max-width: 100%;
  }
  a .recommendations {
    color: $gray-light !important;
  }
  .recommendations {
    color: $gray-light;

    font-size: 14px;
    overflow: auto;
    padding-left: 0%;
    line-height: 24px;
  }
  .sticky-contact {
    position: absolute;
    right: -105px !important;
    top: 3px;
    width: 210px;
  }
  .icon-number-text {
    height: 24px;
    width: 24px;
    max-width: 100%;
    float: left;
    margin-top: 4px;
  }
  .icon-number-text img {
    opacity: 0.5;
  }
  .sticky-contact .preview-contact-number,
  .sticky-share .preview-contact-number {
    margin-top: 5px;
  }
  .preview-contact-number {
    padding-left: 34px;
    margin-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
  }
  .preview-contact-number p {
    margin: 0 0 10px;
    font-size: 15px;
  }
  .preview-contact-number a {
    text-decoration-line: underline;
    font-weight: ${rdcUiTheme.typography.weight.medium};
    color: ${rdcUiTheme.color.interactive.primary.default.initial};
  }

  .mobile-number {
    color: $gray-light;
  }
  .sticky-share {
    position: absolute;
    top: 54px;
    right: -24px;
  }
  header.sticky {
    display: block;
    z-index: 1030;
  }

  /* Section CSS */

  .banner_preview-main {
    position: relative;
    background: white;
  }

  .banner_preview-back {
    font-size: 14px;
    letter-spacing: 0.35px;
    line-height: 20px;
    color: #ffffff;
    padding: 18px 112px;
  }
  .banner_preview-back {
    position: absolute;
    width: 100%;
    display: flex;
    padding: 16px 112px;
    align-items: center;
    z-index: 3;
  }
  #backbutton {
    display: flex;
  }
  a {
    color: $brand-primary;
    text-decoration: none;
  }
  a {
    background-color: transparent;
  }
  .banner_preview-back-icon {
    font-size: 18px;
    margin-right: 8px;
    width: 40px;
    height: 40px;
    background-color: rgba(51, 51, 51, 0.4);
    border-radius: 8px;
  }
  .banner_preview-back-icon img {
    color: #ffffff;
    text-decoration: none;
    font-weight: 300;
    padding: 8px;
    cursor: pointer;
  }
  .banner_preview-back-icon-right {
    font-size: 14px;
    letter-spacing: 0.35px;
    line-height: 23px;
    color: #ffffff;
    cursor: pointer;
    display: none;
  }
  .banner_preview {
    background-size: cover;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    max-height: 325px;
    position: relative;
  }
  .banner_preview::before {
    display: block;
    content: "";
    width: 100%;
    padding-bottom: 31.51%;
  }
  .banner_cover_photo {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }
  .fallBackImg {
    position: absolute;
    width: 100%;
    height: 101%;
    object-fit: cover;
  }
  .banner_cover_photo_bg {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: white;
  }
  .banner_cover_photo img {
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .banner_cover_photo_bg img {
    min-width: 100%;
    min-height: 100%;
    opacity: 0.8;
    filter: alpha(opacity=80);
    -webkit-filter: blur(20px);
    -moz-filter: blur(20px);
    -o-filter: blur(20px);
    -ms-filter: blur(20px);
    filter: blur(20px);
  }
  .default-image {
    background-position: center;
    background-image: url(${default_background});
  }
  .no_back_image {
    box-shadow: inset 0 0 200px #000000 !important;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0) 35%,
      rgba(0, 0, 0, 0.5) 100%
    ) !important;
  }
  .banner_img_parent {
    opacity: 0.8;
    -webkit-filter: blur(75px);
    filter: blur(75px);
    height: 100%;
    width: 100%;
    position: absolute;
    clip: rect(0px, auto, 520px, 0px);
    background-repeat: no-repeat;
    background-size: cover;
  }
  .banner_img_child {
    position: relative;
    display: block;
    margin: auto;
    max-width: 100%;
    background-repeat: no-repeat;
    height: 400px;
    background-size: contain;
    background-position: center;
  }
  .profile-details-box-left {
  }
  * {
    box-sizing: border-box;
  }

  html {
    width: 100%;
    min-height: 100%;
  }

  body {
    width: inherit;
    min-height: inherit;
    margin: 0;
    padding: 0;
  }
  .profile-Tiltle-Team-top {
    border-radius: 16px;
    background-color: ${rdcUiTheme.color.gray[300]};
    padding: 2px 8px 2px 8px;
    height: 23px;
    width: 50px;
    color: ${rdcUiTheme.color.text.primary};
    font-size: 12px;
    font-weight: ${rdcUiTheme.typography.weight.bold};
    line-height: 11px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
    position: absolute;
    top: -32px;
  }
  .profile-Tiltle-Team-top {
    top: -14px;
  }
  .badge {
    font-size: 14px;
    font-weight: ${rdcUiTheme.typography.weight.medium};
    color: ${rdcUiTheme.color.text.secondary};
    line-height: 20px;
  }
  @include mobile {
    .default-image {
      background-image: url(${default_background_mobile});
    }
    .banner_img_child {
      background-size: cover;
      height: 240px;
    }
    .banner_preview {
      max-height: 240px;
      width: 100%;
    }
    .banner_preview::before {
      padding-bottom: 33.51%;
    }

    .banner_img_parent {
      height: 252px;
      clip: rect(0px, auto, 252px, 0px);
    }
    ._preview-main_header {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 1001;
      overflow: auto;
      background: #fff;
      box-shadow: 0 7px 14px 0 rgba(0, 0, 0, 0.06);
      height: 125px;
    }
    ._preview-main_header {
      display: none !important;
    }
    .banner_preview-back {
      padding: 16px 10px;
    }

    .profile-Tiltle p {
      display: flex;
    }
    .profile-Tiltle {
      width: 78%;
    }
  }

  @include tab {
    .banner_img_child {
      background-size: cover;
      height: 288px;
    }
    header.sticky {
      display: none;
    }
  }
`;
